import { render, staticRenderFns } from "./ModuleTitle.vue?vue&type=template&id=5e7f3b66&scoped=true&"
import script from "./ModuleTitle.vue?vue&type=script&lang=js&"
export * from "./ModuleTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f3b66",
  null
  
)

export default component.exports